import constants from 'common/constants'

import {ONBOARDING_TRACK_EVENTS} from './ActionTypes/ApiActionTypes'

/**
 * POST onboarding/track-events — batched analytics events.
 *
 * `body.events` is an ORDERED array of `{event_name, substep, metadata?}`: the
 * subscription service applies it sequentially and synthesises earlier funnel
 * substeps from the sequence, so the array order IS data — callers must push
 * events in the order the user completed them and never sort/dedupe the array
 * (see ONBOARDING_BULK_EVENTS spec §2). Top-level `urdd_id`/`metadata` are
 * batch defaults merged shallowly under each event's own values.
 *
 * The server caps a batch at 25 events; `trackOnboardingEvents` in
 * common/helpers/onboardingEventTracking.ts chunks before dispatching.
 */
export const trackEventsBatch = (body, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_TRACK_EVENTS,
    payload: {
      apiUrl: constants.api_onboarding_track_events,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
